module.exports = __webpack_public_path__ + "portal-static/img/1.45a59c6b.jpg";